import { ActionButtonVariants } from 'components/action-button';
import { getDesignToken, primitive, spacing } from 'styles/constants';
export default {
  itemNameFontWeight: undefined,
  itemImageBackgroundColor: primitive.$greyFive,
  itemBorderTopWidth: '1px',
  itemBorderTopColor: primitive.$greyFive,
  itemPaddingY: spacing.$2_5,
  itemPaddingX: '$2',
  emptyCartBtnVariant: ActionButtonVariants.OUTLINE,
  buttonContainerMarginY: '$6',
  buttonContainerMarginX: '$2',
  headerFontSize: '3xl',
  headerColor: getDesignToken('text-default'),
  headerFontWeight: undefined,
  headerBorderBottomWidth: 0,
};
